"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentProvider = exports.PaymentGroupName = void 0;
var PaymentGroupName;
(function (PaymentGroupName) {
    PaymentGroupName["IDEAL"] = "IDEAL_SAFERPAY";
    PaymentGroupName["CREDITCARD"] = "CREDITCARD_SAFERPAY";
    PaymentGroupName["PAYPAL"] = "PAYPAL_SAFERPAY";
    PaymentGroupName["KLARNA"] = "KLARNA";
    PaymentGroupName["REMBOURS"] = "REMBOURS";
    PaymentGroupName["APPLEPAY"] = "APPLEPAY";
    PaymentGroupName["BANCONTACT"] = "BANCONTACT";
    PaymentGroupName["BANCONTACT_SAFERPAY"] = "BANCONTACT_SAFERPAY";
    PaymentGroupName["CARTE_BLEUE"] = "CARTE BLEUE";
    PaymentGroupName["APPLEPAY_SAFERPAY"] = "APPLEPAY_SAFERPAY";
    PaymentGroupName["GOOGLEPAY_SAFERPAY"] = "GOOGLEPAY_SAFERPAY";
    PaymentGroupName["ECOCHEQUE"] = "ECOCHEQUE";
})(PaymentGroupName || (exports.PaymentGroupName = PaymentGroupName = {}));
var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["SAFERPAY"] = "SAFERPAY";
    PaymentProvider["CLOSEBROTHERS"] = "CLOSEBROTHERS";
    PaymentProvider["KLARNA"] = "KLARNA";
    PaymentProvider["WORLDLINE"] = "WORLDLINE";
})(PaymentProvider || (exports.PaymentProvider = PaymentProvider = {}));
//# sourceMappingURL=BuyPaymentEnums.js.map